import request from '../request'


const packageApis = {
    getPackage: (id, query) => request.get(`/packages/${id}${query}`),
    createPackage: (payload) => request.post(`/packages`, payload),
    updatePackage: (id, payload) => request.patch(`/packages/${id}`, payload),
    getPackages: (query) => request.get(`/shop-packages${query}`),
    getPackageDetail: (id, query) => request.get(`/packages/${id}${query}`),
    getPackageStatusGroups: (query) => request.get(`/package-status-group-with-count${query}`),
    cancelPackages: (id) => request.patch(`/packages/${id}/cancel`),
    getPricing: (payload) => request.post(`/pricings/shipping-fee`, payload),
    savePackageDraft: (payload) => request.post(`/package-draft`, payload),
    getShippingFeeValue: (payload) => request.post(`/price-details/shipping-fee`, payload),
    createPackagesFromFile: (payload) => request.post(`/create-packages-from-file`, payload),
    validatePackage: (payload) => request.post(`/validate-package`, payload),
    validatePackages: (payload) => request.post(`/validate-packages`, payload).then(response => response.data)
        .catch(error => {
            throw error;
        }),
    findPackageByCode: (query) => request.get(`/package${query}`),
    getInfoReceiverByPhone: (query) => request.get(`/receivers${query}`),
    printPackageAWBForOMS: (id) => request.get(`/packages/${id}/oms-awb`),
    retryPushPackageToOms: (id) => request.post(`/packages/${id}/retry-push-to-oms`),
    retryPackageByShop: () => request.post(`/shop/retry-packages`),
    getPackageWaitingWithCountByShop: (query) => request.get(`/shop/package-waiting-with-count${query}`),
    createPackageFromDraft: (id) => request.put(`/packages/${id}/update-draft`),
    printMultiplePackage: (query, payload) => request.post(`/packages-multiple-awb${query}`, payload, {
        responseType: 'blob'
    }),
    exportPackage: (params:String) => request.get(`/shop-export-package${params}`,{
        responseType: 'blob',
        headers: {
            "Content-Type": "multipart/form-data"
        },
    }),
}

export default packageApis;
